export default [{
  path: '/admin/apply/files/list',
  name: 'filesList',
  component: () => import('@/views/apply/files/list'),
  meta: {
    title: '档案列表',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/files/config',
  name: 'filesConfig',
  component: () => import('@/views/apply/files/config'),
  meta: {
    title: '档案设置',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/files/detail',
  name: 'filesDetail',
  component: () => import('@/views/apply/files/detail'),
  meta: {
    title: '档案详情',
    headType: 0,
    auth: true
  }
}]



// WEBPACK FOOTER //
// ./src/router/apply/files.js